import { makeRequests } from "../../api";

export const getArticles = (offset) => makeRequests('get', 'pages/?format=json&type=home.BlogPage&fields=main_image&limit=10&offset=' + offset)
